module.exports = __webpack_public_path__ + "img/greekandlatin.e34bc230.png";